import { createReducer } from 'redux-act';
import * as actions from '#app/actions/spendingBudget';

interface SpendingBudgetState {
  modalVisible: boolean;
}

const initialState: SpendingBudgetState = {
  modalVisible: false,
};

const setSpendingBudgetModalVisible = (
  state: SpendingBudgetState,
  bool: boolean
): SpendingBudgetState => ({
  ...state,
  modalVisible: bool,
});

export default createReducer<SpendingBudgetState>(
  {
    [actions.setSpendingBudgetModalVisible as any]: setSpendingBudgetModalVisible,
  },
  initialState
);
